import angular from 'angular';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';
import { guid1 } from '@/shared/utils/guid';
import dompurify from 'dompurify';

angular
  .module('cxSettings')
  .controller('EditTaskTemplateDialogCtrl', [
    '$element',
    '$scope',
    '$http',
    'appUrls',
    'flySvc',
    'resourceFactorySvc',
    'resourceNameFilter',
    'close',
    'costResources',
    'parameterDefinitions',
    'mainTaskTemplateId',
    'taskTemplate',
    editTaskTemplateDialogCtrl,
  ]);

function editTaskTemplateDialogCtrl(
  $element,
  $scope,
  $http,
  appUrls,
  flySvc,
  resourceFactorySvc,
  resourceNameFilter,
  close,
  costResources,
  parameterDefinitions,
  mainTaskTemplateId,
  taskTemplate,
) {
  var vm = this;
  vm.showValidation = false;
  vm.taskTemplate = taskTemplate;
  vm.model = {
    costResourceId: taskTemplate.costResourceId,
    costParameterDefinitionId: taskTemplate.costParameterDefinitionId,
    costRegistrationUserId: taskTemplate.costRegistrationUserId,
  };
  vm.costResources = costResources;
  vm.documentation = null;

  if (!vm.costResources) {
    resourceFactorySvc.get('resource').reg(
      {
        type: 1,
      },
      function(data) {
        vm.costResources = data
          .map(item => ({
            ...item,
            label: resourceNameFilter(item),
            code: item.code || '',
          }))
          .sort(dynamicSortMultiple('code', 'label'));
      },
    );
  }
  $http.get(`${appUrls.tasks}/api/tasktemplates/documentation/${taskTemplate.id}`).then(
    function({ data }) {
      vm.documentation = data;
    },
    error => flySvc.error(error),
  );

  vm.setDocumentation = () => {
    const documentation = vm.isDocumentationEmpty(vm.documentation) ? null : vm.documentation;
    $http.put(`${appUrls.tasks}/api/tasktemplates/${taskTemplate.id}/documentation`, {
      documentation,
    });
  };

  vm.onCostResourceChange = function() {
    if (!vm.model.costResourceId) {
      vm.model.costParameterDefinitionId = null;
      vm.model.costRegistrationUserId = null;
    }
  };

  vm.parameterDefinitions = parameterDefinitions;
  if (!vm.parameterDefinitions) {
    $http.get(`${appUrls.tasks}/api/TaskParameters/Definitions/${mainTaskTemplateId}`).then(
      function({ data }) {
        vm.parameterDefinitions = data.sort(dynamicSortMultiple('name'));
      },
      error => flySvc.error(error),
    );
  }

  vm.isDocumentationEmpty = documentation => {
    // Small hack to render document in hidden div, and then retrieve text content
    // seemed more useful than regex replace. The inner content of the ckEditor always
    // contains some high-level HTML tags without content, so a simple 'empty' check
    // on the string value isn't sufficient.
    const div = document.createElement('div');
    div.innerHTML = dompurify.sanitize(documentation);
    return !div.textContent.trim();
  };

  vm.save = function() {
    if ($scope.form.$invalid) return;
    vm.saving = true;

    let model = angular.copy(taskTemplate);

    model.costResourceId = vm.model.costResourceId;
    model.costParameterDefinitionId = vm.model.costParameterDefinitionId;
    model.costRegistrationUserId = vm.model.costRegistrationUserId;

    delete model.assignedTo;
    delete model.mailTemplate;
    delete model.tags;
    vm.setDocumentation();

    $http.put(appUrls.tasks + '/api/tasktemplates/templates', model).then(
      function({ data = {} }) {
        vm.saving = false;
        $element.modal('hide');
        close(data, 500);
        flySvc.success();

        taskTemplate.costResourceId = model.costResourceId;
        taskTemplate.costParameterDefinitionId = model.costParameterDefinitionId;
        taskTemplate.costRegistrationUserId = model.costRegistrationUserId;
        taskTemplate.documentation = model.documentation;

        return false;
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error);
      },
    );
  };

  vm.showValidationErrors = function() {
    vm.showValidation = true;
    if (vm.translation && vm.translation.isValid) vm.translation.isValid(true);
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
